import { memo } from 'react';

import { PostOrPage } from '@tryghost/content-api';
import _ from 'lodash';

import BlogPostBox from 'components/BlogPostBox';

import * as S from './styles';

interface IBlogPostGrid {
  blogPosts: PostOrPage[];
}

const BlogPostGrid = ({ blogPosts }: IBlogPostGrid) => (
  <S.BlogPostsGrid>
    {blogPosts.map((blogPost) => (
      <BlogPostBox blogPost={blogPost} key={blogPost.slug} />
    ))}
  </S.BlogPostsGrid>
);

export default memo(
  BlogPostGrid,
  (prevProps, nextProps) =>
    _.map(prevProps.blogPosts, 'slug') === _.map(nextProps.blogPosts, 'slug')
);
